import AstroStaticPage from "@/common/components/AstroStaticPage";
import React from "react";
import { Data } from "./data";

const Palmistry = () => {
  return <AstroStaticPage data={Data} />;
};

export default Palmistry;
